import styled from '@emotion/styled';
import {
	Link,
	Responsive,
	InstagramIcon,
	XLogoIcon,
	ITheme,
	Css,
	YouTubeIcon,
} from '@/ui';
import FacebookIcon from '../../../assets/icons/socials/facebook.svg';
import LinkedInIcon from '../../../assets/icons/socials/linkedin.svg';
import { Color } from '../../../styles/Color';

export enum ISocialLinkItemPlatform {
	Facebook = 'Facebook',
	Instagram = 'Instagram',
	Twitter = 'Twitter',
	LinkedIn = 'LinkedIn',
	YouTube = 'YouTube',
	Pinterest = 'Pinterest',
}

export interface ISocialLinkItem {
	url: string;
	platform: ISocialLinkItemPlatform;
}

export interface IFooterSocialLinksProps {
	links: ISocialLinkItem[];
}

export function FooterSocialLinks({ links }: IFooterSocialLinksProps) {
	return <FooterSocialLinksWrap>{links.map(renderLink)}</FooterSocialLinksWrap>;
}

function renderLink({ platform, url }: ISocialLinkItem) {
	const Icon = getIconForPlatform(platform);
	return (
		<Link
			key={url}
			href={url}
			title={platform}
			aria-label={`CVG Airport on ${platform}`}
			target="_blank"
			rel="noopener"
			hideExternalIndicator
		>
			<Icon aria-label={platform} alt="Opens in new window" />
		</Link>
	);
}

function getIconForPlatform(platform: ISocialLinkItemPlatform) {
	switch (platform) {
		case 'Facebook':
			return FacebookIcon;

		case 'Instagram':
			return InstagramIcon;

		case 'Twitter':
			return XLogoIcon;

		case 'LinkedIn':
			return LinkedInIcon;

		case 'YouTube':
			return YouTubeIcon;

		default:
			throw new Error(`No icon available for platform: ${platform}`);
	}
}

const FooterSocialLinksWrap = styled.div<{}, ITheme>`
	display: flex;
	justify-content: flex-end;
	gap: ${Css.pxToRemFromTheme(16)};
	width: 100%; // Ensure the container takes the full width of its parent

	svg {
		width: 24px;
		height: unset;

		path {
			fill: ${Color.PrimaryBlue17};
		}

		&:hover {
			path {
				fill: ${Color.PrimaryBlue};
			}
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: ${Css.pxToRemFromTheme(40)};
		justify-content: space-between;
	}
`;
